import { c as _c } from "react/compiler-runtime";
import { MessageFab } from "@/components/molecules/MessageFab/MessageFab";
import { RealEstateType } from "@/types/real-estate";
import { useRealEstateDetailMobileMessageFab } from "./useRealEstateDetailMobileMessageFab";
type Props = {
  detailData: RealEstateType;
  // On the full page the mobile bottom navbar is present, so lift the FAB above
  // it; in the dialog there's no navbar and it keeps the default offset.
  aboveNavbar?: boolean;
};
export function RealEstateDetailMobileMessageFab(t0) {
  const $ = _c(9);
  const {
    detailData,
    aboveNavbar
  } = t0;
  let t1;
  if ($[0] !== detailData) {
    t1 = {
      detailData
    };
    $[0] = detailData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    handleSendMessage,
    user,
    label,
    availability
  } = useRealEstateDetailMobileMessageFab(t1);
  const t2 = user?.name;
  const t3 = user?.image;
  const t4 = aboveNavbar ? "bottom-safe-22 translate-y-1" : "translate-y-2.5";
  let t5;
  if ($[2] !== availability || $[3] !== handleSendMessage || $[4] !== label || $[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = <MessageFab onClick={handleSendMessage} label={label} userName={t2} userImage={t3} subtitle={availability} className={t4} data-sentry-element="MessageFab" data-sentry-component="RealEstateDetailMobileMessageFab" data-sentry-source-file="RealEstateDetailMobileMessageFab.tsx" />;
    $[2] = availability;
    $[3] = handleSendMessage;
    $[4] = label;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}